module.exports = __webpack_public_path__ + "img/project-architectural.1f091b5f.svg";